import { IDataTableColumn, Loading } from "nsitools-react";
import * as React from "react";

import { JudgeApi, JudgeSearch, JudgeGridDto } from "../../../../api";
import { ICustomSelectorProps, SRSHCustomSelector } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface ICompetitionJudgeSelectionProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  editMode: boolean;
  loading: boolean;
}

export const CompetitionJudgeSelection: React.FunctionComponent<ICompetitionJudgeSelectionProps> = ({
  editMode,
  linkedIds,
  onLinkedIdsChanged,
  loading,
}) => {
  const api = useApiService(JudgeApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "name",
        render: (row: JudgeGridDto) => <div>{row.name}</div>,
      },
      {
        header: () => t(ETLCodes.MailAddress),
        fieldName: "email",
      },
    ],
    [t]
  );

  const searchIdsFunction = React.useCallback(
    (sObj: any) => api.searchAllIds(JudgeSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const searchFunction = React.useCallback(
    (sObj: any) => api.baseSearch(JudgeSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <Loading isLoading={loading || linkedIds === null}>
      <SRSHCustomSelector
        linkedIds={linkedIds}
        columns={columns}
        onLinkedIdsChanged={onLinkedIdsChanged}
        idField="judgeId"
        searchFunction={searchFunction}
        searchIdsFunc={searchIdsFunction}
        editMode={editMode}
        showAllButtons={false}
        exportFunction={(sObj) =>
          api.exportXlsFile(
            JudgeSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, excludeSelectedIds: false })
          )
        }
      />
    </Loading>
  );
};
